import React from 'react';
import { handleActions } from 'redux-actions';
import { availableBackgroundImages, availableLogoImages } from '../../constants/availableImages';
import * as ActionTypes from '../../constants/ActionTypes';
import Url from '../../../lib/config';

const initialState = {
    available: {
        hotelLogo: availableLogoImages,
        backgroundImage: availableBackgroundImages
    },
    current: {}
};

const imagesReducer = handleActions(
    {
        [ActionTypes.IMAGES_ADD_TO_LIBRARY]: (state, action) => {
            let completeImage = {
                original: Url.download + '/' + action.image.original,
                thumbnail: Url.download + '/' + action.image.thumbnail
            };
            let available = { ...state.available, [action.target]: [...state.available[action.target], completeImage] };
            return { ...state, available, current: { [action.target]: completeImage } };
        },
        [ActionTypes.IMAGES_UPLOAD_FAILURE]: (state, action) => {
            //TODO Report image upload failure back to UI
            console.log('error uploading new image for ' + action.target + ': ' + action.error);
        }
    },
    initialState
);

export default imagesReducer;



// WEBPACK FOOTER //
// ./src/reducers/theme/images.js